if (!customElements.get('cr-header-drawer')) {
  const BaseDrawer = customElements.get('header-drawer');
  if (BaseDrawer) {
    customElements.define('cr-header-drawer', class extends BaseDrawer {
      bindEvents() {
        this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
        this.querySelector('[data-cr-close]')?.addEventListener('click', (event) => this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')));
        this.querySelectorAll('.cr-drawer-accordion').forEach((details) => {
          details.addEventListener('toggle', () => {
            details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
            if (details.open) this.querySelectorAll('.cr-drawer-accordion').forEach((other) => { if (other !== details) other.open = false; });
          });
        });
      }
      onKeyUp(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
        }
      }
    });
  }
}
document.querySelectorAll('.cr-mega-menu').forEach((details) => {
  details.addEventListener('toggle', () => {
    details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
    if (details.open) document.querySelectorAll('.cr-mega-menu').forEach((other) => { if (other !== details) other.open = false; });
  });
  details.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      details.open = false;
      details.querySelector('summary').focus();
    }
  });
});
